import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Text, mergeClassNames } from '@clockout-dev/design-elements';
import styles from './styles/emptyState.module.scss';

/**
 * Compact placeholder used inside configuration panels (e.g. Fee Structure
 * → Advanced Fee Configurations, Available Balance → Advanced
 * Configurations) when the rule list is empty. Sits where rows would
 * normally render so the panel never collapses to "just an add button".
 *
 * Props:
 * - `icon` — optional node rendered inside the circular badge. Defaults
 *   to an inbox icon.
 * - `title` — main message ("No rules yet" by default).
 * - `description` — optional secondary line nudging the user to add the
 *   first row.
 * - `className` — extra class merged onto the root container.
 */
export default function EmptyState({
    icon = <InboxOutlined style={{ fontSize: 20 }} />,
    title = 'No rules yet',
    description,
    className,
    showIcon = false,
}) {
    return (
        <div className={mergeClassNames([styles.empty, className])}>
            {
                showIcon 
                    ? <span className={styles.icon} aria-hidden="true">{icon}</span> 
                    : null
            }
            <Text as="span" size="s" className={styles.title}>
                {title}
            </Text>
            {description ? (
                <Text as="span" size="xs" className={styles.description}>
                    {description}
                </Text>
            ) : null}
        </div>
    );
}
